﻿import type { NuxtError } from '#app';

export default function getAllErrorMessages(error: NuxtError) {
    if (isStringArray(error.data)) return error.data;

    if (typeof error.data === 'string') return [error.data];

    return [error.statusText || error.message];
}
